import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router';
import App from './App.vue'
import router from './app-routing'
import store from './stores/GlobalStore'
import ToastService from 'primevue/toastservice';
import VueI18n from 'vue-i18n'
import VueLodash from 'vue-lodash'
import { cloneDeep } from 'lodash'

Vue.prototype.$isNotEmpty = function(obj = {}) {
  let result = true;
  result = result && obj != null;
  result = result && obj !== undefined;
  if (obj instanceof String) {
    result = result && obj !== '';
  }
  result = result && Object.keys(obj).length !== 0 || obj.constructor !== Object;
  return result;
};

Vue.use(ToastService);
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VueI18n);
// name is optional
Vue.use(VueLodash, { lodash: { cloneDeep } });

// Ready translated locale messages
const messages = {
  fr: require('./assets/i18n/fr.json'),
  en: require('./assets/i18n/en.json')
};

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'fr', // set locale
  messages, // set locale messages
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
